import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export interface GradeY {
  id: number;
  descricao?: string;
  isInativo: boolean;
}

export interface GradeYFormData {
  descricao?: string;
  isInativo?: boolean;
}

export function useGradesY() {
  const queryClient = useQueryClient();

  const { data: gradesY = [], isLoading } = useQuery({
    queryKey: ["grades-y"],
    queryFn: async () => {
      const { data } = await apiClient.get<GradeY[]>("/api/grades-y");
      return data;
    },
  });

  const createGradeY = useMutation({
    mutationFn: async (formData: GradeYFormData) => {
      const { data } = await apiClient.post<GradeY>("/api/grades-y", formData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["grades-y"] });
      toast.success("Grade Y criada com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao criar Grade Y: " + error.message);
    },
  });

  const updateGradeY = useMutation({
    mutationFn: async ({ id, ...formData }: GradeYFormData & { id: number }) => {
      const { data } = await apiClient.put<GradeY>(`/api/grades-y/${id}`, formData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["grades-y"] });
      toast.success("Grade Y atualizada com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao atualizar Grade Y: " + error.message);
    },
  });

  const deleteGradeY = useMutation({
    mutationFn: async (id: number) => {
      await apiClient.delete(`/api/grades-y/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["grades-y"] });
      toast.success("Grade Y inativada com sucesso!");
    },
    onError: (error: Error) => {
      toast.error("Erro ao inativar Grade Y: " + error.message);
    },
  });

  return {
    gradesY,
    isLoading,
    createGradeY,
    updateGradeY,
    deleteGradeY,
  };
}
